// extracted by mini-css-extract-plugin
export var box = "_t-0";
export var check = "_t-1";
export var checkboxButton = "_t-6";
export var checkboxGroup = "_t-5";
export var disabled = "_t-7";
export var ghost = "_t-9";
export var input = "_t-2";
export var label = "_t-4";
export var normal = "_t-8";
export var uncheck = "_t-3";